<template>
	<div class="timer">
		<span class="timeItem">{{timerArr[0][0]}}</span>
		<span class="timeItem">{{timerArr[0][1]}}</span>
		<span class="colonItem">:</span>
		<span class="timeItem">{{timerArr[1][0]}}</span>
		<span class="timeItem">{{timerArr[1][1]}}</span>
		<span class="colonItem">:</span>
		<span class="timeItem">{{timerArr[2][0]}}</span>
		<span class="timeItem">{{timerArr[2][1]}}</span>
	</div>
</template>

<script>
import utils from '@/utils/utils'

export default{
	props: ['expireTime', 'onTimerExpired'],
	data(){
		return {
			timerArr: [['0', '0'], ['0', '0'], ['0', '0']],
			timeDifference: this.expireTime - (new Date().getTime()/1000|0)
		}
	},
	created(){
		this.initTimer()
	},
	methods: {
		initTimer(){
			this.intervalTimer = setInterval(() => {
				this.timeDifference --
				this.createTimerArr(this.timeDifference)
				if(this.timeDifference <= 0){
					clearInterval(this.intervalTimer)
					this.onTimerExpired && this.onTimerExpired()
				}
			}, 1000)
		},
		createTimerArr(dtime){
			if(dtime <= 0){
				this.timerArr = [['0', '0'], ['0', '0'], ['0', '0']]
				return
			}else{
				let dHours = dtime/3600 | 0
				let dMinutes = dtime%3600/60 | 0
				let dSeconds = dtime%60
				let tempArr = [['0', '0'], ['0', '0'], ['0', '0']]
				tempArr[0] = utils.padZero(dHours, 2).split('')
				tempArr[1] = utils.padZero(dMinutes, 2).split('')
				tempArr[2] = utils.padZero(dSeconds, 2).split('')
				this.timerArr = tempArr
			}
		}
	}
}
</script>

<style scoped>
.timer{
	margin: 13px 0;
	text-align: center;
	overflow: hidden;
}
.timeItem{
	display: inline-block;
	font-size: 14px;
	padding: 3px 5px;
	margin-right: 5px;
	background-color: #eaecf2;
	border-radius: 2px;
}
.timeItem:last-child{
	margin-right: 0;
}
.colonItem{
	margin-right: 5px;
}
</style>